export default {
  queryLogistics: '/gateway/capp/mallcenter/OrderCenterRpcService/queryLogistics'
}
